import { ValidationMethod } from '@/helpers/validation/Validator';
import i18n from '@/localization/localization';

const required: ValidationMethod = (input, key = '') => {
    let check = input !== undefined && input !== null && input !== '';

    if (input && Array.isArray(input)) {
        check = input.length > 0;
    }

    return {
        success: check,
        message: !check ? i18n.t('validation.validation_required', { key }).toString() : undefined,
    };
};

export default required;
